<script>
  import { onMount, getContext } from "svelte";
  import { useNavigate } from "svelte-navigator";
  import LoginLayout from "lib/components/layout/login/LoginLayout.svelte";

  const session = getContext("session");

  const navigate = useNavigate();

  onMount(() => {
    if (session.isValid) {
      session.refresh().then((value) => {
        // Avoids infinite loop
        if (value) {
          navigate("/app/");
        }
      });
    }
  });
  $$restProps;
</script>

<svelte:head>
  <title>Sign In • paxray</title>
</svelte:head>

<LoginLayout />
